import { Box } from "@mui/material";
import "./index.css";
import BannerComponent from "../../Components/BannerComponent";
import { ServicesSectionId } from "../../constants/constants";
import useScreenSize from "../../hooks/useScreenSize";

const Services = () => {
  const { isLessThanMd } = useScreenSize();

  return (
    <Box
    className=""
    sx={{
        margin: isLessThanMd ? "0px 20px 50px 20px" : "0px 0px 50px 0px",
    }}
>
      <Box className="container">
        <BannerComponent
          title="Enabling growth through affordable loans"
          sectionTitle="Services"
          body="Tresor Micro empowers communities with affordable loans for growth."
        />
      </Box>
      <Box className="container">
        <header className="page-section-header">
          <h1>What We Offer!</h1>
        </header>
        <section className="page-section">
          <h2>SERVICES</h2>
          <p>
            Tresor Micro serves as an effective tool for poverty alleviation and
            economic empowerment by granting access to financial services like
            personal Loan, Group Loan Business Loan. Tresor Micro plays a
            pivotal role in providing these services to the unserved and
            underserved population, enabling them to initiate or expand small
            businesses and elevate their incomes.
          </p>
          <p>
            The organization extends both financial and non-financial services
            to resource-poor, unbanked, and marginalized individuals in rural
            and semi-urban areas. These services are tailored to meet the
            evolving needs of communities engaged in agricultural and small
            business activities. wherein poor women mutually guarantee each
            other’s loans, the organization ensures a robust support system.
            Monthly meetings with borrowers follow a highly disciplined
            approach. The repayment rates on the company’s collateral-free loans
            exceed 99% due to diligent monitoring and follow-up on loan
            utilization. Additionally, Tresor Micro has systematically
            introduced various individual need-based products for its clients.
          </p>
        </section>
        <section className="page-section" id={ServicesSectionId.GroupLoan}>
          <h2>Group Loan</h2>
          <p>
            Rural Empower offers loans as a convenient financial solution for
            households, especially women, in rural areas looking to expand their
            businesses or explore new livelihood opportunities. By providing
            access to capital, these loans enable clients to diversify their
            income sources through agricultural ventures, microbusinesses, or by
            supporting industries like handicrafts and handlooms. Designed to be
            flexible and accessible, these loans require minimal documentation
            and offer a streamlined process, making them ideal for those aiming
            to strengthen their financial stability. With competitive interest
            rates, Rural Empower’s loan program empowers underserved communities
            to overcome economic challenges and improve their livelihoods.
          </p>
        </section>
        <section className="page-section" id={ServicesSectionId.PersonalLoan}>
          <h2>Personal Loan</h2>
          <p>
            Rural Empower provides financial assistance as a convenient solution
            for marginalized groups who have historically been excluded from
            mainstream financial services. This inclusive program specifically
            targets individuals such as persons with disabilities, transgender
            people, single mothers, widows, unmarried women, and those affected
            by leprosy. By offering accessible, flexible financial support with
            minimal documentation, the program empowers these underserved
            communities to meet their unique needs and improve their economic
            well-being. With competitive terms and a streamlined application
            process, Rural Empower helps individuals overcome financial barriers
            and enhance their livelihoods.
          </p>
        </section>
        <section className="page-section" id={ServicesSectionId.GoldLoan}>
          <h2>Gold Loan</h2>
          <p>
            Tresor Micro offers Gold Loans as a convenient financial solution
            for individuals in rural and semi-urban areas who may not have
            access to traditional credit. By leveraging their gold assets,
            clients can secure quick, collateral-free loans to meet urgent
            financial needs. These loans are designed to be flexible and
            accessible, with minimal paperwork, and are ideal for those looking
            to address immediate expenses such as medical emergencies,
            education, or business-related needs. With competitive interest
            rates and a streamlined application process, the Gold Loan program
            empowers underserved populations to overcome financial barriers and
            improve their livelihoods.
          </p>
        </section>
        <section className="page-section" id={ServicesSectionId.BusinessLoan}>
          <h2>Business Loan</h2>
          <p>
            Tresor Micro provides Business Loans to help entrepreneurs and small
            business owners in rural communities expand and grow their
            businesses. Whether it’s for working capital, purchasing equipment,
            or diversifying income streams, the Business Loan program supports a
            wide range of entrepreneurial ventures, including agriculture,
            handicrafts, and small-scale industries. By providing accessible,
            affordable financing, Tresor Micro helps clients build sustainable
            businesses, increase their incomes, and create jobs, driving local
            economic growth and poverty reduction.
          </p>
        </section>
      </Box>
    </Box>
  );
};

export default Services;
